/* eslint-disable */
import createWorker from 'workerize-loader!../workers/upload.worker'
import * as UploadWorker from '../workers/upload.worker'

const uploadWorker = createWorker<typeof UploadWorker>()

export const useUploadWorker = () => uploadWorker
